import { createSlice } from '@reduxjs/toolkit';
import axios from "axios";
import AppContext from '../../../AppContext';

export const usuarioSlice = createSlice({
    name: 'usuarios',
    initialState: {
        usuario:{llave: ''},
        ctacte: [],
        alumno: []
    },
    reducers: {
        setUsuarios: (state, action) => {
            return {...state, ctacte:[], usuario:action.payload };
        },
        setCtaCte:(state, action)=> {
            return {...state, ctacte: action.payload };
        },
        setAlumnos: (state, action) => {
            state.alumno = action.payload;
        },
    },
});

export const { setUsuarios, setCtaCte , setAlumnos} = usuarioSlice.actions;
export default usuarioSlice.reducer;
export const fetchUsuarios = (usuario, onSuccess, onError) => (dispatch) => {
  const urlLogin = `${AppContext.baseApiUrl}${AppContext.urlServiceLogin}`;
  const urlCta = `${AppContext.baseApiUrl}${AppContext.urlServiceCta}`;
  const urlAlumno = `${AppContext.baseApiUrl}${AppContext.urlServiceAlumno}`;

  axios.post(urlLogin, usuario)
    .then((response) => {
      dispatch(setUsuarios(response.data));

      const headers = {
        "Content-Type": "application/json",
        key: response.data.llave,
      };

      axios.get(urlCta, { headers })
        .then((responseCta) => {
          dispatch(setCtaCte(responseCta.data));

          axios.get(urlAlumno, { headers })
            .then((responseAlumno) => {
              dispatch(setAlumnos(responseAlumno.data));
              onSuccess(response.data);
            })
            .catch(onError);
        })
        .catch(onError);
    })
    .catch(onError);
};
